export function getSeriesGenerator(from) {
    var num = from || 1;
    return {
        next: function () {
            return num++;
        }
    };
}
